import { TaskSubTicketStatus } from 'dy-frontend-http-repository/lib/modules/TaskSubTicket/resources/TaskSubTicketResource';
import React from 'react';

import { taskSubTicketStatusInformation } from '@app/data/consts';
import { Button, ButtonGroup, FormGroup } from '@blueprintjs/core';

export interface StatusSegmentedControlProps {
    value: TaskSubTicketStatus;
    isChanging?: boolean;
    onChange: (status: TaskSubTicketStatus) => void;
}

export type Props = StatusSegmentedControlProps;

// Exactly four statuses exist and all twelve transitions between them are permitted, so this is
// a flat selector rather than a stepper. Nothing here touches the timer.
const STATUSES: TaskSubTicketStatus[] = ['to_design', 'in_progress', 'in_revision', 'complete'];

const StatusSegmentedControl: React.FC<Props> = ({ value, isChanging = false, onChange }) => {
    return (
        <FormGroup label="Phase status">
            <ButtonGroup>
                {STATUSES.map((status) => {
                    const statusInformation = taskSubTicketStatusInformation[status];
                    const isActive = status === value;

                    return (
                        <Button
                            key={status}
                            active={isActive}
                            // Selection is the only thing that fills here. In a selector the
                            // question is "which one is chosen", so exactly one segment is solid
                            // and the rest are outlined in the colour they would take if picked.
                            // The status CHIP is a different question and keeps its own rule.
                            outlined={!isActive}
                            disabled={isChanging}
                            style={
                                isActive ?
                                    { background: statusInformation.color, color: '#FFFFFF' }
                                :   {
                                        background: 'transparent',
                                        color: statusInformation.color,
                                        borderColor: statusInformation.color,
                                    }
                            }
                            onClick={() => {
                                if (isActive) {
                                    return;
                                }

                                onChange(status);
                            }}
                        >
                            {statusInformation.title}
                        </Button>
                    );
                })}
            </ButtonGroup>
        </FormGroup>
    );
};

export default StatusSegmentedControl;
